import { z } from "zod";

export const getDraftsListRequestSchema = z.object({
  q: z.string().trim().min(1).optional(),
  p: z.coerce.number().int().positive().default(1),
  s: z.coerce
    .number()
    .int()
    .positive()
    .refine((value) => [10, 25, 50, 100].includes(value), {
      message: "Invalid page size",
    })
    .default(10),
});

export type GetDraftsListRequest = z.infer<typeof getDraftsListRequestSchema>;
